import PatientClinicalInsight from "../types/PatientClinicalInsight";
import { ClinicalInsightValueTypes } from "../types/ClinicalInsightValueTypes";

export const clinicalInsightPrimaryValue = (
  insight: PatientClinicalInsight
): string =>
  insight.insight_values?.find(
    (v) => v.value_type === ClinicalInsightValueTypes.PRIMARY_VALUE
  )?.insight_value ?? "";

export const clinicalInsightTimestampRaw = (
  insight: PatientClinicalInsight
): string | undefined =>
  insight.insight_values?.find(
    (v) => v.value_type === ClinicalInsightValueTypes.INSIGHT_TIMESTAMP
  )?.insight_value;

// For missing milestone sort_order: after every finite sort_order.
const milestoneSortOrder = (i: PatientClinicalInsight): number =>
  i.milestone?.sort_order ?? Number.POSITIVE_INFINITY;

const milestoneDisplayName = (i: PatientClinicalInsight): string =>
  i.milestone?.display_name ?? "";

// Sort first by sort_order, then display_name or id
export const compareClinicalInsightsByMilestone = (
  a: PatientClinicalInsight,
  b: PatientClinicalInsight
): number => {
  const orderA = milestoneSortOrder(a);
  const orderB = milestoneSortOrder(b);
  if (orderA !== orderB) return orderA - orderB;
  const nameCmp = milestoneDisplayName(a).localeCompare(
    milestoneDisplayName(b),
  );
  return nameCmp !== 0 ? nameCmp : a.id - b.id;
};

export const sortClinicalInsights = (
  insights: PatientClinicalInsight[]
): PatientClinicalInsight[] => [...insights].sort(compareClinicalInsightsByMilestone);
